import { createSelector } from 'reselect';
import { RootState } from 'src/redux/store';

const selectAuditState = (state: RootState) => state.audit;

const selectAuditList = createSelector(
  selectAuditState,
  (state) => state.audits
);

const selectAuditParams = createSelector(
  selectAuditState,
  (state) => state.auditParams
);

const selectIsLoading = createSelector(
  selectAuditState,
  (state) => state.isLoading
);

const selectAuditPagination = createSelector(
  selectAuditState,
  (state) => state.paginationMeta
);

export const selectors = {
  selectAuditList,
  selectAuditParams,
  selectIsLoading,
  selectAuditPagination
};
